import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { SolutionOverview } from '../components/SolutionOverview';
import { DashboardShowcase } from '../components/DashboardShowcase';
import { FeatureGrid } from '../components/FeatureGrid';
import { MobileAppSection } from '../components/MobileAppSection';
import { BusinessImpact } from '../components/BusinessImpact';
import { IntegrationSection } from '../components/IntegrationSection';
import { TrustSection } from '../components/TrustSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ScrollToTop } from '../components/ScrollToTop';
interface HomeProps {
  onNavigate?: (page: 'home' | 'fitur' | 'kontak') => void;
}
export function Home({
  onNavigate
}: HomeProps) {
  return <div className="min-h-screen bg-white text-foreground antialiased" data-id="element-477">
      <SEO data-id="element-478" />
      <Navbar onNavigate={onNavigate} data-id="element-479" />
      <main data-id="element-480">
        <HeroSection onNavigate={onNavigate} data-id="element-481" />
        <SolutionOverview data-id="element-482" />
        <DashboardShowcase onNavigate={onNavigate} data-id="element-483" />
        <FeatureGrid onNavigate={onNavigate} data-id="element-484" />
        <MobileAppSection data-id="element-485" />
        <BusinessImpact data-id="element-486" />
        <IntegrationSection data-id="element-487" />
        <TrustSection data-id="element-488" />
        <CTASection data-id="element-489" />
      </main>
      <Footer onNavigate={onNavigate} data-id="element-490" />
      <ScrollToTop data-id="element-491" />
    </div>;
}